// frontend/src/services/authService.js
import { getApiBase, apiRequest as request } from './api';

const API_BASE = getApiBase();

const authService = {
    async getCurrentUser() {
        const response = await request('/api/auth/me', {
            method: 'GET'
        });
        return normalizeResponse(response);
    },

    async register({ username, password, email }) {
        const response = await request('/api/auth/register', {
            method: 'POST',
            body: { username, password, email }
        });
        return normalizeResponse(response);
    },

    async login({ username, password }) {
        const response = await request('/api/auth/login', {
            method: 'POST',
            body: { username, password }
        });
        return normalizeResponse(response);
    },

    async logout() {
        try {
            const response = await request('/api/auth/logout', {
                method: 'POST'
            });
            return normalizeResponse(response);
        } catch (error) {
            // Навіть якщо logout повернув помилку (наприклад, відсутня сесія),
            // вважаємо користувача розлогіненим
            return { success: false, authenticated: false };
        }
    },

    async changePassword({ currentPassword, newPassword }) {
        const response = await request('/api/auth/change-password', {
            method: 'POST',
            body: { currentPassword, newPassword }
        });
        if (!response || typeof response !== 'object') {
            throw new Error('Невідома помилка зміни пароля');
        }
        if (response.success === false) {
            throw new Error(response.message || 'Не вдалося змінити пароль');
        }
        return response;
    }
};

function normalizeResponse(response) {
    if (!response || typeof response !== 'object') {
        return { success: false, authenticated: false };
    }
    const user = response.user || null;
    const isGuest = Boolean(user?.isGuest);
    const sanitizedUser = isGuest ? null : user;
    const authenticated = Boolean(
        response.authenticated !== undefined
            ? response.authenticated && !isGuest
            : sanitizedUser && !isGuest
    );
    return {
        success: Boolean(response.success ?? true),
        authenticated,
        user: sanitizedUser,
        isGuest,
        message: response.message || response.error || null,
    };
}

export default authService;
export { API_BASE };
